import { render, staticRenderFns } from "./ed-class-builder-remove-placeholder.component.vue?vue&type=template&id=0874984b&scoped=true&"
import script from "./ed-class-builder-remove-placeholder.component.ts?vue&type=script&lang=ts&"
export * from "./ed-class-builder-remove-placeholder.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-class-builder-remove-placeholder.component.scss?vue&type=style&index=0&id=0874984b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0874984b",
  null
  
)

export default component.exports